import { render, staticRenderFns } from "./sendMail.vue?vue&type=template&id=5c78272c&scoped=true"
import script from "./sendMail.vue?vue&type=script&lang=js"
export * from "./sendMail.vue?vue&type=script&lang=js"
import style0 from "./sendMail.vue?vue&type=style&index=0&id=5c78272c&prod&lang=scss&scoped=true"
import style1 from "./sendMail.vue?vue&type=style&index=1&id=5c78272c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c78272c",
  null
  
)

export default component.exports